<h1 class="row justify-content-center">{{'dpo.i18n.consultation.popup.title' | translate}}</h1>
<div mat-dialog-content>
    <div class="mat-elevation-z8" [hidden]="!(operationList && operationList.length > 0)">
        <table mat-table [dataSource]="dataSource" matSort #sort="matSort" aria-describedby="operationDetailsTable">

            <!-- RRDI Column -->
            <ng-container matColumnDef="rrdi">
                <th id="rrdi" mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'dpo.i18n.table.header.rrdi' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.rrdi}} </td>
            </ng-container>

            <!-- VIN Column -->
            <ng-container matColumnDef="vin">
                <th id="vin" mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'dpo.i18n.table.header.vin' | translate}}
                </th>
                <td mat-cell *matCellDef="let element"> {{element.vin}} </td>
            </ng-container>

            <!-- Basket Folder Number Column -->
            <ng-container matColumnDef="basketFolderNumber">
                <th id="basketFolderNumber" mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'dpo.i18n.table.header.backetFolderNumber' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.basketFolderNumber}} </td>
            </ng-container>

            <!-- Feature Column -->
            <ng-container matColumnDef="prestation">
                <th id="prestation" mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'dpo.i18n.table.header.feature' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.prestation}} </td>
            </ng-container>

            <!-- ECU Column -->
            <ng-container matColumnDef="appCode">
                <th id="appCode" mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'dpo.i18n.table.header.ecu' | translate}}
                </th>
                <td mat-cell *matCellDef="let element"> {{element.appCode}} </td>
            </ng-container>

            <!-- Brand Column -->
            <ng-container matColumnDef="brand">
                <th id="brand" mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'dpo.i18n.table.header.brand' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.brand}} </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="label">
                <th id="label" mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'dpo.i18n.table.header.status' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.label}} </td>
            </ng-container>

            <!-- Subscription Date Column -->
            <ng-container matColumnDef="subscriptionDate">
                <th id="subscriptionDate" mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'dpo.i18n.table.header.subscription.date' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.subscriptionDate | date}} </td>
            </ng-container>

            <!-- Operation Date Column -->
            <ng-container matColumnDef="operationDate">
                <th id="operationDate" mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'dpo.i18n.table.header.operation.date' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.operationDate | date}} </td>
            </ng-container>

            <!-- Execution Date Column -->
            <ng-container matColumnDef="executionDate">
                <th id="executionDate" mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'dpo.i18n.table.header.execution.date' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.executionDate | date}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator #paginator [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>
    </div>
</div>
<div class="row justify-content-end action-button">
    <button class="btn" (click)="export()"
        *ngIf="operationList && operationList.length > 0">{{'dpo.i18n.consultation.button.export' | translate}}</button>
    <button class="btn" (click)="close()" cdkFocusInitial>{{'dpo.i18n.consultation.button.close' | translate}}</button>
</div>